import { toast } from 'sonner';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';
import GroupsProjects from './GroupsProjects';
import ServicesInfo from './ServicesInfo';
import StepResolutionPanel from './StepResolutionPanel';
import ConversationsModal from './ConversationsModal';
import ImageGeneratorModal from './ImageGeneratorModal';
import ImageGallery from './ImageGallery';
import DiagramGeneratorModal from './DiagramGeneratorModal';
import InstallAppModal from './InstallAppModal';
import { BACKEND_URL as API } from '../config/api';

const HomeModals = ({
  token,
  showGroupsProjects, setShowGroupsProjects,
  showServicesInfo, setShowServicesInfo,
  showStepPanel, setShowStepPanel,
  openConversationsModal, setOpenConversationsModal,
  showImageGenerator, setShowImageGenerator,
  showImageGallery, setShowImageGallery,
  showDiagramGenerator, setShowDiagramGenerator,
  showInstallApp, setShowInstallApp,
  conversations,
  currentConversation,
  selectConversation,
  deleteConversation,
  handleSaveImageToGallery,
}) => {
  const { language } = useLanguage();
  const es = language === 'es';
  const handleCopy = async (conv) => {
    try {
      const response = await axios.get(`${API}/conversations/${conv.id}`, {
      });
      const fullConv = response.data;
      const text = fullConv.messages?.map(m => `${m.role === 'user' ? (es ? 'Usuario' : 'User') : 'DamyxIA'}: ${m.content}`).join('\n\n') || '';
      if (text) {
        try {
          await navigator.clipboard.writeText(text);
        } catch {
          const textArea = document.createElement('textarea');
          textArea.value = text;
          textArea.style.cssText = 'position:fixed;left:-999999px;top:-999999px;opacity:0;';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }
        toast.success(es ? 'Conversación copiada al portapapeles' : 'Conversation copied to clipboard');
      } else {
        toast.error(es ? 'La conversación está vacía' : 'The conversation is empty');
      }
    } catch (error) {
      console.error('Error copying conversation:', error);
      toast.error(es ? 'Error al copiar la conversación' : 'Error copying conversation');
    }
  };

  const handleExport = async (conv) => {
    try {
      const response = await axios.get(`${API}/conversations/${conv.id}`, {
      });
      const fullConv = response.data;
      
      const title = fullConv.title || `Conversación ${conv.id.slice(0, 8)}`;
      const date = new Date(fullConv.created_at).toLocaleDateString('es-ES');
      let content = `# ${title}\n`;
      content += `Fecha: ${date}\n\n`;
      content += '---\n\n';
      
      fullConv.messages?.forEach(m => {
        const role = m.role === 'user' ? 'Usuario' : 'DamyxIA';
        content += `## ${role}\n\n${m.content}\n\n---\n\n`;
      });
      
      const blob = new Blob([content], { type: 'text/markdown' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${title.replace(/[^a-zA-Z0-9]/g, '_')}_${date.replace(/\//g, '-')}.md`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      toast.success('Conversación descargada');
    } catch (error) {
      toast.error('Error al descargar la conversación');
    }
  };

  return (
    <>
      {/* Groups & Projects Modal */}
      {token && token !== 'guest' && (
        <GroupsProjects 
          isVisible={showGroupsProjects}
          onClose={() => setShowGroupsProjects(false)}
        />
      )}
      
      {/* Services Info Modal */}
      {token && token !== 'guest' && (
        <ServicesInfo 
          isVisible={showServicesInfo}
          onClose={() => setShowServicesInfo(false)}
        />
      )}
      
      {/* Step Resolution Panel */}
      {token && token !== 'guest' && showStepPanel && (
        <StepResolutionPanel 
          onClose={() => setShowStepPanel(false)}
        />
      )}
      
      {/* Conversations Modal */}
      <ConversationsModal
        isOpen={openConversationsModal}
        onClose={() => setOpenConversationsModal(false)}
        conversations={conversations}
        currentConversation={currentConversation}
        onSelect={(id) => {
          selectConversation(id);
          setOpenConversationsModal(false);
        }}
        onDelete={deleteConversation}
        onCopy={handleCopy}
        onExport={handleExport}
      />
      
      {/* Image Generator Modal */}
      <ImageGeneratorModal
        isOpen={showImageGenerator}
        onClose={() => setShowImageGenerator(false)}
        conversationId={currentConversation?.id}
        onSaveImage={handleSaveImageToGallery}
      />
      
      {/* Image Gallery Modal */}
      <ImageGallery
        isOpen={showImageGallery}
        onClose={() => setShowImageGallery(false)}
      />
      
      {/* Diagram Generator Modal */}
      <DiagramGeneratorModal
        isOpen={showDiagramGenerator}
        onClose={() => setShowDiagramGenerator(false)}
        conversationId={currentConversation?.id}
      />
      
      {/* Install App Modal */}
      <InstallAppModal
        isOpen={showInstallApp}
        onClose={() => setShowInstallApp(false)}
      />
    </>
  );
};

export default HomeModals;
